import { SessionLedgerEntry } from "@/redux/services/pos/pos.type";

// System-generated movement reasons are stored as translation keys (e.g. the
// expense-linked pay-out/void movements). Resolve them to French for display;
// free-text reasons (manual movements) fall through unchanged.
const LEDGER_REASON_LABELS: Record<string, string> = {
  "expense.movement.pay_out": "Dépense",
  "expense.movement.void_pay_in": "Annulation d'une dépense",
};

export const getLedgerReasonLabel = (
  reason?: string | null,
): string | undefined => {
  if (!reason) return undefined;
  return LEDGER_REASON_LABELS[reason] ?? reason;
};

// Movement metadata is mostly internal references (UUIDs) that must never be
// shown raw. Only these keys are surfaced, with French labels.
export const LEDGER_METADATA_LABELS: Record<string, string> = {
  payee: "Bénéficiaire",
};

/**
 * The expense a ledger entry references — drawer-backed expense pay-outs and
 * their compensating void pay-ins stash the expense uuid on the movement
 * metadata as `expenseUuid`. Returns it so the entry can link to the expense.
 */
export const resolveLedgerExpenseUuid = (
  entry: SessionLedgerEntry,
): string | null => {
  const uuid = entry.metadata?.expenseUuid;
  return typeof uuid === "string" ? uuid : null;
};

/**
 * The order a ledger entry references: the normalized `order` field, or — for a
 * movement (e.g. a refund) — the order stashed on its metadata as
 * `order_uuid` / `order_number`.
 */
export function resolveLedgerOrder(
  entry: SessionLedgerEntry
): { id: string; orderNumber: string } | null {
  if (entry.order) return entry.order;
  const meta = entry.metadata;
  const uuid = meta?.order_uuid;
  const number = meta?.order_number;
  if (
    typeof uuid === "string" &&
    (typeof number === "string" || typeof number === "number")
  ) {
    return { id: uuid, orderNumber: String(number) };
  }
  return null;
}
